import { useScrollReveal } from '../../../hooks/useScrollReveal';

const bullets = [
  {
    icon: "ri-phone-off-line",
    number: "01",
    title: "Missed calls = lost jobs",
    desc: "Every unanswered call is a customer walking to your competitor. In service businesses, speed is everything.",
  },
  {
    icon: "ri-time-line",
    number: "02",
    title: "Slow follow-up = lost clients",
    desc: "Speed to lead is everything. Delays of even a few hours cost you deals before they start.",
  },
  {
    icon: "ri-tools-line",
    number: "03",
    title: "Manual processes = bottlenecks",
    desc: "Your team's time is wasted on tasks that should run automatically, every single day.",
  },
  {
    icon: "ri-link-unlink-m",
    number: "04",
    title: "Disconnected tools = inefficiency",
    desc: "Fragmented systems create gaps where leads fall through and revenue disappears.",
  },
];

const ProblemSection = () => {
  const { ref: headRef, visible: headVisible } = useScrollReveal();
  const { ref: gridRef, visible: gridVisible } = useScrollReveal();
  const { ref: closeRef, visible: closeVisible } = useScrollReveal();

  return (
    <section className="bg-[#1d1d1f] py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header — big centered statement */}
        <div
          ref={headRef}
          className={`reveal-el ${headVisible ? 'is-visible' : ''} text-center max-w-4xl mx-auto mb-20`}
        >
          <p className="text-sapphire text-xs font-bold uppercase tracking-widest mb-8">The Problem</p>
          <h2 className="text-5xl lg:text-6xl xl:text-7xl font-black text-white leading-[1.04] tracking-tight">
            Most Businesses Lose<br className="hidden lg:block" /> Revenue in Their Operations
          </h2>
        </div>

        {/* Pain point grid */}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {bullets.map((b, i) => (
            <div
              key={b.title}
              className={`reveal-el stagger-${i + 1} ${gridVisible ? 'is-visible' : ''} group bg-white/[0.04] border border-white/[0.08] rounded-3xl p-10 hover:bg-white/[0.07] transition-colors duration-300`}
            >
              <div className="flex items-start justify-between mb-8">
                <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/10">
                  <i className={`${b.icon} text-white/50 text-xl`}></i>
                </div>
                <span className="text-4xl font-black text-white/[0.06] tracking-tight">{b.number}</span>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{b.title}</h3>
              <p className="text-white/40 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>

        {/* Closing statement */}
        <div
          ref={closeRef}
          className={`reveal-el ${closeVisible ? 'is-visible' : ''} text-center mt-20`}
        >
          <p className="text-2xl lg:text-4xl font-black text-white/30 leading-snug">
            It's not a lead problem.<br />
            <span className="text-white">It's a systems problem.</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
